import {Button} from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface OfficerTeamsAndConditionsViewModalProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly content: string;
}

export function OfficerTeamsAndConditionsViewModal({
  open,
  onClose,
  content,
}: Readonly<OfficerTeamsAndConditionsViewModalProps>) {
  const displayContent = content.trim() || "No content available.";

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent
        className="inset-4 flex max-h-[calc(100dvh-2rem)] translate-x-0 translate-y-0 flex-col overflow-hidden sm:inset-auto sm:top-[50%] sm:left-[50%] sm:right-auto sm:bottom-auto sm:max-h-[min(100dvh-2rem,90dvh)] sm:w-full sm:max-w-3xl sm:translate-x-[-50%] sm:translate-y-[-50%]"
        showCloseButton
      >
        <DialogHeader className="shrink-0 space-y-2 pr-8 sm:pr-0">
          <DialogTitle className="text-balance break-words sm:pr-6">
            Officer Employment Conditions
          </DialogTitle>
          <DialogDescription>
            Reference information for officers. You can close this at any time.
          </DialogDescription>
        </DialogHeader>

        <div className="flex min-h-0 flex-1 flex-col gap-4">
          <div
            className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden rounded-md border bg-muted/50 p-4 text-sm whitespace-pre-wrap break-words [overflow-wrap:anywhere]"
            role="article"
          >
            {displayContent}
          </div>

          <Button
            className="w-full shrink-0 [touch-action:manipulation]"
            variant="outline"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
